<template>
  <md-card>
    <md-card-header data-background-color="orange" class="md-layout">
      <h4 class="title filter-by">
        Filter By
        <md-button
          v-if="allowRemoveAll && showRemoveAll"
          class="md-icon-button md-dense"
          @click="removeFilters(Object.keys(filters))"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </h4>
    </md-card-header>

    <md-card-content class="filters">
      <md-list>
        <template v-if="addDateRadio">
          <md-subheader class="filter-radio">
            Date
            <md-button
              class="md-icon-button md-dense"
              @click="removeFilters(['dateRadio'])"
              v-if="filters.dateRadio.value"
            >
              <md-icon>clear</md-icon>
            </md-button>
          </md-subheader>
          <md-radio v-model="filters.dateRadio.value" :value="computeRelativeDate({ dayOffset: -1 })"
            >Last Day</md-radio
          >
          <md-radio v-model="filters.dateRadio.value" :value="computeRelativeDate({ dayOffset: -7 })"
            >Last Week</md-radio
          >
          <md-radio v-model="filters.dateRadio.value" :value="computeRelativeDate({ monthOffset: -7 })"
            >Last Month</md-radio
          >
          <md-divider></md-divider>
        </template>
        <template v-if="addDateRange">
          <md-subheader class="filter-radio">
            Date Range
            <md-button
              class="md-icon-button md-dense"
              @click="removeFilters(['startDate', 'endDate'])"
              v-if="filters.startDate.value || filters.endDate.value"
            >
              <md-icon>clear</md-icon>
            </md-button></md-subheader
          >
          <div class="md-layout">
            <transition name="fade">
              <div class="md-layout-item md-size-100 filter-error" v-if="errors.dateRange">
                <span class="md-error text-danger md-caption">{{ errors.dateRange }}</span>
              </div>
            </transition>
            <div class="md-layout-item md-xlarge-size-50 md-medium-size-100">
              <md-datepicker
                :md-model-type="String"
                md-placement="left-end"
                v-model="filters.startDate.value"
                md-immediately
              >
                <label>From:</label>
              </md-datepicker>
            </div>
            <div class="md-layout-item md-xlarge-size-50 md-medium-size-100">
              <md-datepicker
                :md-model-type="String"
                md-placement="left-end"
                v-model="filters.endDate.value"
                md-immediately
              >
                <label>To:</label>
              </md-datepicker>
            </div>
          </div>
        </template>
      </md-list>
    </md-card-content>
  </md-card>
</template>

<script>
import { computed, ref, watch } from "@vue/composition-api";
import { constructSyntax } from "@/components/FilterCard/constructSyntax";
import moment from "moment";

export default {
  name: "FilterCard",
  props: {
    title: {
      type: String,
      default: "Filter By",
    },
    allowRemoveAll: {
      type: Boolean,
      default: true,
    },
    addDateRange: {
      type: Boolean,
      default: true,
    },
    addDateRadio: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const computeRelativeDate = ({ yearOffset = 0, monthOffset = 0, dayOffset = 0 }) => {
      const today = new Date();

      return moment(
        new Date(today.getFullYear() + yearOffset, today.getMonth() + monthOffset, today.getDate() + dayOffset)
      ).format("YYYY-MM-DD");
    };
    const filters = ref({
      startDate: {
        leftOperand: "DATE",
        operator: ">=",
        value: "",
      },
      endDate: {
        leftOperand: "DATE",
        operator: "<=",
        value: "",
      },
      dateRadio: {
        leftOperand: "DATE",
        operator: ">=",
        value: "",
      },
    });
    const errors = ref({
      dateRange: "",
    });

    const showRemoveAll = computed(() =>
      Object.keys(filters.value)
        .map((key) => Boolean(filters.value[key].value))
        .reduce((previousValue, currentValue) => previousValue || currentValue, false)
    );
    const removeFilters = (filterNames) => {
      filterNames.forEach((key) => (filters.value[key].value = null));
    };

    const submit = () => {
      emit("submit", constructSyntax(filters.value));
    };
    watch(
      () => [filters.value.endDate.value, filters.value.startDate.value, filters.value.dateRadio.value],
      () => submit(),
      { deep: false, immediate: false }
    );
    watch(
      () => [filters.value.endDate.value, filters.value.startDate.value],
      () => {
        if (
          filters.value.endDate.value &&
          filters.value.startDate.value &&
          new Date(filters.value.startDate.value) >= new Date(filters.value.endDate.value)
        ) {
          errors.value.dateRange = "Invalid date range";
          setTimeout(() => {
            errors.value.dateRange = "";
            removeFilters(["startDate", "endDate"]);
          }, 2000);
        }
      }
    );
    return {
      computeRelativeDate,
      filters,
      showRemoveAll,
      removeFilters,
      submit,
      errors,
    };
  },
};
</script>

<style lang="scss" scoped>
.filter-error {
  padding-bottom: 8px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
